module.exports = __webpack_public_path__ + "img/UTEAST-6.2336750a.jpg";